import {
  FETCH_GEO_AREAS_REQUEST,
  FETCH_GEO_AREAS_SUCCESS,
  FETCH_GEO_AREAS_FAILURE,
  SAVE_GEO_AREA_REQUEST,
  SAVE_GEO_AREA_SUCCESS,
  SAVE_GEO_AREA_FAILURE,
  DELETE_GEO_AREA_REQUEST,
  DELETE_GEO_AREA_SUCCESS,
  DELETE_GEO_AREA_FAILURE,
} from './types';

const INITIAL_STATE = {
  geoAreaList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_GEO_AREAS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_GEO_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        geoAreaList: action.payload,
      };

    case FETCH_GEO_AREAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        geoAreaList: [],
      };
    case SAVE_GEO_AREA_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_GEO_AREA_SUCCESS:
      return {
        ...state,
      };

    case SAVE_GEO_AREA_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_GEO_AREA_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_GEO_AREA_SUCCESS:
      return {
        ...state,
      };

    case DELETE_GEO_AREA_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
